export default __webpack_public_path__ + "static/media/side_home.127c5f13.svg";